import { MagicWand, Whatsapp } from '@huspy/briks-icons';
import {
  Box, Flex, Text
} from '@huspy/briks-web';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import briksTheme from '@shared/briks-theme';
import { useTranslation } from 'react-i18next';

export const WhatsAppChatBot = () => {
  const { t } = useTranslation();

  return (
    <Box mb='6'>
      <a
        href='https://wa.link/qlvk7z'
        target='_blank'
        rel='noreferrer'
        style={ { width: 'fit-content', display: 'block' } }
        onClick={ () => {
          trackAmplitudeEvent(
            USER_EVENTS.BANK_PRODUCTS.MORTGAGE_AI_CHATBOT_ATTEMPTED
          );
        } }
      >
        <Flex
          bg='indigo.50'
          border='1px solid'
          borderRadius='2'
          align='center'
          borderColor='indigo.300 !important'
          p='2'
          w='fit-content'
          gap='2'
        >
          <Whatsapp height='20' width='20' style={ { color: '#10B981' } } />
          <Text size='lg'>{t('bankProducts.chatBot.questions')}</Text>
          <Text size='lg'>{t('bankProducts.chatBot.ask')}</Text>
          <Text size='lg' color='indigo.500'>
            {t('bankProducts.chatBot.ai')}
          </Text>
          <MagicWand style={ { color: briksTheme.colors['indigo.500'] } } />
        </Flex>
      </a>
    </Box>
  );
};
